import { IconProps } from '../';

const defaultSize = 48;

export const ErrorIcon = ({ size, className }: IconProps) => {
  const sizeToUse = size || defaultSize;
  return (
    <svg
      className={className}
      height={sizeToUse}
      width={sizeToUse}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 2.66669C8.62663 2.66669 2.66663 8.62669 2.66663 16C2.66663 23.3734 8.62663 29.3334 16 29.3334C23.3733 29.3334 29.3333 23.3734 29.3333 16C29.3333 8.62669 23.3733 2.66669 16 2.66669ZM21.7333 21.7334C21.2133 22.2534 20.3733 22.2534 19.8533 21.7334L16 17.88L12.1466 21.7334C11.6266 22.2534 10.7866 22.2534 10.2666 21.7334C9.74663 21.2134 9.74663 20.3734 10.2666 19.8534L14.12 16L10.2666 12.1467C9.74663 11.6267 9.74663 10.7867 10.2666 10.2667C10.7866 9.74669 11.6266 9.74669 12.1466 10.2667L16 14.12L19.8533 10.2667C20.3733 9.74669 21.2133 9.74669 21.7333 10.2667C22.2533 10.7867 22.2533 11.6267 21.7333 12.1467L17.88 16L21.7333 19.8534C22.24 20.36 22.24 21.2134 21.7333 21.7334Z"
        fill="#B20101"
      />
    </svg>
  );
};
